export * from './IconFileTransparent';
